export const API_ENDPOINTS = {
  // Newsletters Email Subscription
  NEWSLETTERS: {
    SUBSCRIBE: "/web/subscribe",
  },

  // Contact Us
  CONTACT: {
    CONTACT_US: "/web/contact",
  },

  // Blogs
  BLOGS: {
    GET_BLOGS_CATEGORIES: "/web/blogs/get-categories",
    GET_BLOG_BY_SLUG: "/web/blogs/get-blog-by-slug",
    GET_BLOGS: "/web/blogs/get-blogs",
  },
  // User
  USER: {
    GET_USERS: "/auth/get-user-list-light",
  },
  // Vacancy
  VACANCY: {
    GET_VACANCIES: "/web/vacancy/list",
    GET_VACANCY_UNIQUE_DEPARTMENT: "/web/vacancy/departments",
    GET_VACANCY_DETAILS: "/web/vacancy/details",
    APPLY_VACANCY: "/web/vacancy/apply",
  },
};

export const API_UPLOAD_ENDPOINTS = {
  blog_cover_image: "blog/cover",
  user_profile_image: "profile",
  blog_content: "blog/content",
};

export const get_upload_full_url = (
  path: keyof typeof API_UPLOAD_ENDPOINTS,
  filename: string
) => {
  return `${process.env.NEXT_PUBLIC_DOMAIN}/uploads/${API_UPLOAD_ENDPOINTS[path]}/${filename}`;
};
